import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { Video } from "../VideoPlayerCoreTypes";

var BasePlayerEmbed = /*#__PURE__*/function (_Component) {
  _inherits(BasePlayerEmbed, _Component);

  var _super = _createSuper(BasePlayerEmbed);

  function BasePlayerEmbed() {
    var _this;

    _classCallCheck(this, BasePlayerEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "iframe", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleIframeRef", function (ref) {
      _this.iframe = ref;
    });

    return _this;
  }

  _createClass(BasePlayerEmbed, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.player !== Video.KALTURA) {
        this.loadVideo();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.src !== prevProps.src && this.props.player !== Video.KALTURA) {
        this.loadVideo();
      }
    }
  }, {
    key: "loadVideo",
    value: function loadVideo() {
      if (this.props.src) {
        this.iframe.src = this.props.src;
      }

      if (this.props.onFrameReady) {
        this.props.onFrameReady(this.iframe);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.player === Video.KALTURA) {
        return /*#__PURE__*/React.createElement("video", {
          controls: true,
          disablePictureInPicture: true,
          className: this.props.getClassName({
            descendantName: "frame"
          })
        }, /*#__PURE__*/React.createElement("source", {
          src: this.props.src,
          type: "video/mp4"
        }));
      }

      return /*#__PURE__*/React.createElement("iframe", {
        allowFullScreen: true,
        allow: "autoplay; fullscreen",
        className: this.props.getClassName({
          descendantName: "frame"
        }),
        frameBorder: "0",
        height: 281,
        id: this.props.id,
        ref: this.handleIframeRef,
        width: 500
      });
    }
  }]);

  return BasePlayerEmbed;
}(Component);

export default BasePlayerEmbed;